module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/strikethrough-bfceecb73e7bfd1cd6475aea5f1b3715.svg";